export const userNotifications: string[] = [
  "new_overlapping_pole",
  "pole_date_change",
  "pole_status_change",
  "assessed_pole_data_change",
  "issue_update",
];
